"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureStore = configureStore;
const redux_1 = require("redux");
const redux_saga_1 = __importDefault(require("redux-saga"));
const redux_freeze_1 = __importDefault(require("redux-freeze"));
const localized_path_1 = require("@shared/localized-path");
// import { routerMiddleware } from 'connected-react-router';
const main_1 = require("@src/sagas/main");
const parse_query_1 = require("@src/helpers/parse-query");
const reducers_1 = __importDefault(require("../reducers"));
let history = {
    location: {
        pathname: '',
    },
    listen: () => undefined,
    createHref: () => undefined,
    getQuery: () => undefined,
    push: (path) => undefined,
    pushLocalized: (path) => { },
};
function configureStore(intialState) {
    if (typeof document !== 'undefined') {
        // eslint-disable-next-line global-require
        const { createBrowserHistory } = require('history');
        history = createBrowserHistory();
        // wrap history.push with localized path
        history.pushLocalized = (path) => {
            const language = (0, localized_path_1.getLanguageFromPathname)(history.location.pathname);
            const localizedPath = (0, localized_path_1.getLocalizedPath)(path, language);
            history.push(localizedPath);
        };
        // eslint-disable-next-line func-names
        history.getQuery = function () {
            const query = (0, parse_query_1.parseQuery)(this.location.search);
            return query;
        };
    }
    // add the middlewares
    const middlewares = [];
    const sagaMiddleware = (0, redux_saga_1.default)();
    if (typeof window !== 'undefined') {
        // add the saga middleware
        middlewares.push(sagaMiddleware);
    }
    // add the freeze dev middleware
    if (process.env.ENVIRONMENT === 'local') {
        middlewares.push(redux_freeze_1.default);
    }
    // apply the middleware
    let middleware = (0, redux_1.applyMiddleware)(...middlewares);
    // add the redux dev tools
    if (process.env.ENVIRONMENT !== 'production' &&
        typeof window !== 'undefined' &&
        window.devToolsExtension) {
        middleware = (0, redux_1.compose)(middleware, window.devToolsExtension());
    }
    // create the store
    const store = (0, redux_1.createStore)((0, reducers_1.default)(), intialState, middleware);
    if (typeof window !== 'undefined') {
        sagaMiddleware.run(main_1.sagas);
    }
    return { store, history };
}
